import { LockClosedIcon } from '@heroicons/react/24/outline'
import parse from 'html-react-parser'
import { classNames } from '../../_helpers'
import { DESCRIPTION_CLASS, INFOTEXT_CLASS, INPUT_CLASS, LABEL_CLASS } from './styles'

type PropType = {
  label: string;
  value: string;
  small?: boolean;
  setValue: (value: string) => void;
  isRequired?: boolean
  disabled?: boolean
  isPrivate?: boolean
  vertical?: boolean;
  infotext?: string
  bottomDescription?: string
}

export const Textareafield = ({ label, value, setValue, small, isRequired, disabled, isPrivate, infotext, bottomDescription }: PropType) => {
  return (
    <label className={'block'}>
      <span className={classNames(LABEL_CLASS, 'mb-1.5', small ? 'text-xs' : 'text-sm')}>
        {isPrivate && (
          <LockClosedIcon className={'w-4 h-4 mr-2 shrink-0'} />
        )}
        {label}
      </span>
      {infotext && (
        <div className={INFOTEXT_CLASS}>{parse(infotext)}</div>
      )}
      <textarea
        value={value}
        rows={5}
        onChange={e => setValue(e.target.value)}
        required={isRequired}
        disabled={disabled}
        className={classNames(INPUT_CLASS, 'max-w-xl', small ? 'text-xs' : 'text-sm')}
      />
      {bottomDescription && (
        <p className={DESCRIPTION_CLASS}>{bottomDescription}</p>
      )}
    </label>
  )
}
